export const GIPHY_QUERY = {
  limit: [
    {
      id: 1000,
      length: 1,
    },
    {
      id: 1001,
      length: 2,
    },
    {
      id: 1002,
      length: 3
    },
    {
      id: 1003,
      length: 4
    },
    {
      id: 1004,
      length: 5,
    },
    {
      id: 1005,
      length: 6,
    },
    {
      id: 1006,
      length: 7,
    },
    {
      id: 1007,
      length: 8
    },
    {
      id: 1008,
      length: 9
    },
    {
      id: 1009,
      length: 10,
    },
  ],
  rating: [
    {
      id: 2000,
      age: 'g',
    },
    {
      id: 2001,
      age: 'pg',
    },
    {
      id: 2002,
      age: 'pg-13'
    },
    {
      id: 2003,
      age: 'r'
    }
  ],
  languages: [
    {
      id: 3000,
      language: 'en',
    },
    {
      id: 3001,
      language: 'fa',
    },
    {
      id: 3002,
      language: 'fr'
    },
    {
      id: 3003,
      language: 'du'
    }
  ]
}